import React from 'react'

import { TagComponent, Tooltip, classnames } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import {
  string, number, oneOfType, bool, arrayOf, shape,
} from 'prop-types'

import { EMPTY_ARRAY } from 'Utils/stableDefaults'

import { buildTooltipContent } from './Utils/buildTooltipContent'

function CollapsedFormat({
  title,
  fullName,
  extensionPath,
  fileCount,
  fileSize,
  version,
  rendererName,
  rendererVersion,
  itemFileVersions = EMPTY_ARRAY,
  index,
  showTooltip = false,
  quantity,
}) {
  const tag = (
    <TagComponent
      key={`format-${index}`}
      color="grey"
      type="ghost"
      className={
        classnames(
          'details-area__tag',
          !extensionPath && 'details-area__tag--no-clickable',
          extensionPath && 'details-area__tag--link',
        )
      }
      href={extensionPath}
    >
      {title}
      {quantity && (
        <span className="details-area__tag-quantity">{`(${quantity})`}</span>
      )}
    </TagComponent>
  )

  if (!showTooltip) {
    return tag
  }

  const tooltipContent = buildTooltipContent({
    fileSize,
    version,
    rendererName,
    rendererVersion,
    itemFileVersions,
    fileCount,
    fullName,
  })

  return (
    <Tooltip
      key={`format-tooltip-${index}`}
      content={tooltipContent}
      id={`format-tooltip-${index}`}
      delayHide={100}
      delayUpdate={500}
      clickable
      html
    >
      {tag}
    </Tooltip>
  )
}

CollapsedFormat.propTypes = {
  title: string.isRequired,
  fullName: string,
  extensionPath: string,
  fileSize: string.isRequired,
  fileCount: number.isRequired,
  version: string,
  rendererName: string,
  rendererVersion: oneOfType([string, number]),
  itemFileVersions: arrayOf(shape({
    version: oneOfType([string, number]),
    rendererName: string,
    rendererVersion: oneOfType([string, number]),
  })),
  index: number.isRequired,
  showTooltip: bool,
  quantity: string,
}

export default CollapsedFormat
